export default __webpack_public_path__ + "static/media/add-tag.812cd829.svg";